import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=0f2371bc&scoped=true&"
import script from "./confirmation.vue?vue&type=script&lang=js&"
export * from "./confirmation.vue?vue&type=script&lang=js&"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=0f2371bc&prod&scoped=true&lang=css&"
import style1 from "./confirmation.vue?vue&type=style&index=1&id=0f2371bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2371bc",
  null
  
)

export default component.exports